<ng-container *ngIf="!showError">
  <h1 class="title">Password Reset Required</h1>
  <p class="description">A password reset is needed for your account to continue.</p>
  <div class="button-container">
    <button class="button button-pill button-reverse" [disabled]="callInProgress" (click)="resetPassword()">
      Reset password
    </button>
  </div>
</ng-container>
<ng-container *ngIf="showError">
  <svg-icon src="/assets/icons/alert-circle.svg" class="alert-icon"></svg-icon>
  <div class="title">Something went wrong</div>
  <p class="description">Your password reset request was not processed. Please try again.</p>
  <p class="description">If the problem persists, contact us at support@kumanu.com.</p>
  <div class="button-container">
    <button class="button button-pill button-reverse full-width" (click)="dismissModal()">Close</button>
  </div>
</ng-container>
